export default __webpack_public_path__ + "static/media/orange-ball-inverted.6226262b.svg";